var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"license-error-container font"},[_c('div',{staticClass:"license-error-inner"},[_c('h1',[_vm._v(_vm._s(_vm.$t("networkComputer.autoCloseOnAdminDisconnect")))]),_c('h3',[_vm._v(_vm._s(_vm.count))])])])}
var staticRenderFns = []

export { render, staticRenderFns }